export default __webpack_public_path__ + "static/media/microsoft.4881c100.png";